import { Button, InputField, TextareaField } from 'components';
import React, { FC } from 'react';
import { Field, Form } from 'react-final-form';
import { validateRequired } from 'validations';

import './CreateLeadForm.styles.scss';
import classNames from 'classnames';

type CreateLeadFormProps = {
  onSubmit: (values: any) => void;
  submitInProgress?: boolean;
};

const CreateLeadForm: FC<CreateLeadFormProps> = (props) => {
  const { onSubmit, submitInProgress } = props;

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="create-lead-form">
          <div className={classNames('create-lead-form__fields', 'form')}>
            <Field
              name="companyName"
              label="Company name *"
              component={InputField}
              placeholder="e.g. Edge & Node"
              validate={validateRequired('Company name is required.')}
            />
            <Field
              name="jobTitle"
              label="Job Title *"
              component={InputField}
              placeholder="e.g. Tech Lead, Site Reliability Engineer"
              validate={validateRequired('Job title is required.')}
            />
            <Field
              name="jobType"
              label="Job type"
              component={InputField}
              placeholder="e.g. Full-time, Contract, Internship"
            />
            <Field
              name="salary"
              label="Salary"
              component={InputField}
              placeholder="e.g. $120,000 – $140,000 per year"
            />
            <Field
              name="location"
              label="Location"
              component={InputField}
              placeholder="e.g. Remote, New York, Berlin"
            />
            <Field
              name="url"
              label="Job posting link"
              component={InputField}
              placeholder="Paste a link to the original job posting"
            />
            <Field
              name="fullJobDescription"
              label="Job description *"
              component={TextareaField}
              placeholder="Paste or write the full job description here"
              rows={8}
              validate={validateRequired('Job description is required.')}
            />
          </div>

          <Button
            type="submit"
            className="submit-button"
            isLoading={submitInProgress}
          >
            Create
          </Button>
        </form>
      )}
    />
  );
};

export default CreateLeadForm;
